<loren-page-content>
    <div class="loren-faq-buttons">
        <div class="loren-faq-buttons-left">
            <button class="mr-2" mat-stroked-button (click)="accordion.openAll()">
                {{ "operations.expand_all" | transloco }}
            </button>
            <button mat-stroked-button (click)="accordion.closeAll()">
                {{ "operations.collapse_all" | transloco }}
            </button>
        </div>
        <a
                mat-stroked-button
                color="primary"
                [href]="'website' | transloco"
                target="_blank">
            {{ "faq.navigate_to_site" | transloco }}
        </a>
    </div>

    <div class="mb-3">
        <mat-accordion multi>
            <loren-faq-section [faqTitle]="'faq.device'" [faqAnswer]="'faq.device_answer'"/>
            <loren-faq-section [faqTitle]="'faq.asset'" [faqAnswer]="'faq.asset_answer'"/>
            <loren-faq-section [faqTitle]="'faq.asset_device_diff'" [faqAnswer]="'faq.asset_device_diff_answer'"/>
            <loren-faq-section [faqTitle]="'faq.activate_device'" [faqAnswer]="'faq.activate_device_answer'"/>
            <loren-faq-section [faqTitle]="'faq.create_asset'" [faqAnswer]="'faq.create_asset_answer'"/>
            <loren-faq-section [faqTitle]="'faq.angie_monitor_reports'"
                               [faqAnswer]="'faq.angie_monitor_reports_answer'"/>
            <loren-faq-section [faqTitle]="'faq.dashboard_asset_arrangement_difference'"
                               [faqAnswer]="'faq.dashboard_asset_arrangement_difference_answer'"/>
            <loren-faq-section [faqTitle]="'faq.company_account_dashboard_difference'"
                               [faqAnswer]="'faq.company_account_dashboard_difference_answer'"/>
            <loren-faq-section [faqTitle]="'faq.battery_life'" [faqAnswer]="'faq.battery_life_answer'"/>
            <loren-faq-section [faqTitle]="'faq.asset_icons'" [faqAnswer]="'faq.asset_icons_answer'"/>
            <loren-faq-section [faqTitle]="'faq.automation_plan_notifications'"
                               [faqAnswer]="'faq.automation_plan_notifications_answer'"/>
            <loren-faq-section [faqTitle]="'faq.automation_plan_continues_notifications'"
                               [faqAnswer]="'faq.automation_plan_continues_notifications_answer'"/>
        </mat-accordion>
    </div>
</loren-page-content>
